/**
 * @file 权限服务接口
 */

import {request} from '@/services';
import type {OnlyProjectIdParams, ProjectId} from '@/types';
import type {PermissionCode} from '@/types/permission';

type PermissionQueryParams = OnlyProjectIdParams;

/** 权限角色查询响应 data */
interface PermissionData {
    /** 项目ID */
    projectId: ProjectId;
    /** 权限码列表 */
    permissionCodes: PermissionCode[];
    /** 角色码列表 */
    roleCodes: string[];
}

/**
 * 权限角色查询
 * @see https://iapi.baidu-int.com/web/project/367583/apis/api-4853641
 */
export const fetchPermissions = async (params?: PermissionQueryParams): Promise<PermissionData> =>
    request.get<PermissionData>('proxy-aicomic/member/permissions', {params});
